export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_16.9fb6cc27.jpg";